module.exports = __webpack_public_path__ + "img/image_3.16a0127a.png";